import { render, staticRenderFns } from "./ConsultationAdd.vue?vue&type=template&id=cb2e4a12&scoped=true"
import script from "./ConsultationAdd.vue?vue&type=script&lang=js"
export * from "./ConsultationAdd.vue?vue&type=script&lang=js"
import style0 from "./ConsultationAdd.vue?vue&type=style&index=0&id=cb2e4a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2e4a12",
  null
  
)

export default component.exports